import { render } from "./InplaySidebar.vue?vue&type=template&id=4508a78f&scoped=true"
import script from "./InplaySidebar.vue?vue&type=script&lang=js"
export * from "./InplaySidebar.vue?vue&type=script&lang=js"

import "./InplaySidebar.vue?vue&type=style&index=0&id=4508a78f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4508a78f"]])

export default __exports__